import { useContext, useEffect, useState, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { I18N, Loading, GlobalContext, I18NContext } from 'commons';
import { selectSignUpSubscriptions } from 'state/selectors/signUpSelectors';
import * as locationActions from 'state/actions/locationActions';
import * as locationSelectors from 'state/selectors/locationSelectors';
import PropTypes from 'prop-types';
import { TablePaginationConfig, Table, Space } from '@eb/antd'
import { Button } from 'reactstrap';
import { orgId } from 'utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const ExpectedLocationList = ({ 
    getExpectedLocationList, 
    expectedLocations,
    expLocExpose,
    expLocEditable,
    isAction = false,
    openAddLocation, 
    setSavedSucceed, 
    edit, 
    setIsExpectedLocation, 
    setIsOpenDeleteConfirm, 
    setExpLocId, 
    setExpLocForMapView, 
    setIsOpenViewOnMap }) => {

    const {
        account: { id: contactId, addresseEditable = true },
      } = useContext(GlobalContext);
    
    const onRender = (...args) => {
        console.log('ExpectedLocationSection rendered', args);
    }
    const i18n = useContext(I18NContext);
    const whichLocation = useRef();

    const [params, setParams] = useState({
        orgId,
        contactId,
        _search: false,
        pageSize: 5,
        pageNo: 1,
        sidx: 'address.arriveDate',
        sord: 'desc',
    })

      useEffect(() => {
          getExpectedLocationList(contactId, params);
        }, [params]);
    

    const actionColumnRender = (record) => {
        const {
            arriveDateTimeStamp,
            expireDateTimeStamp,
            addressGeoCodingSource,
            country,
            streetAddress,
            suite,
            city,
            state,
            postalCode,
            gisLocation,
            locationId,
            newAssetId,
            locationName,
            iata,
            assetName,
            id,
            locationSource,
            travelSegment
        } = record
        const { lat, lon } = gisLocation || {}
        const position = { lat: lat || '', lng: lon || '' };
        const expLocForMapView = { position };
        const isExpectedLocationEditable = expLocEditable && (addressGeoCodingSource == "Manual") && travelSegment == null;
        const viewOnMapDisabled = lat === null && lon === null;
        return (
            <>
        <Button
            onClick={() => { setSavedSucceed(false); setIsExpectedLocation(true); edit(record) }}
            color="link"
            eb-test="ssp_location_link_edit_address"
          >
            <I18N>{isExpectedLocationEditable ? 'ssp.address.grid.edit' : 'ssp.address.grid.view'}</I18N>
          </Button>
          {!viewOnMapDisabled &&
            <Button
              onClick={() => {
                setSavedSucceed(false)
                setExpLocForMapView(expLocForMapView)
                setIsExpectedLocation(true)
                setIsOpenViewOnMap(true);
              }}
              color="link"
              eb-test="ssp_location_link_view_on_map"
            >
              <I18N>ssp.address.viewonmap</I18N>
            </Button>
          }
          {
            isExpectedLocationEditable &&
            <Button
              color="link"
              className="ml-2 p-0"
              aria-label={i18n['location.button.delete.alt.text']}
              onClick={() => {
                setSavedSucceed(false)
                setIsExpectedLocation(true)
                setExpLocId(id);
                setIsOpenDeleteConfirm(true);
              }}
            >
              <FontAwesomeIcon
                icon={faTrashAlt}
                alt={i18n['location.button.delete.alt.text']}
                width="0.875em"
                height="1em"
              />
            </Button>
          }
          </>
        )
    }

    const columns = isAction? useMemo(
        () =>
            [
                {
                    title: <I18N>ssp.address.locationname</I18N>,
                    dataIndex: 'address.locationName',
                    render: (_, {locationName}) => {
                        return <span>{locationName}</span>
                    },
                    width: '15%'
                },
                {
                    title: <I18N>event.documents.list.table.label.type</I18N>,
                    dataIndex: 'type',
                    render: (_, record) => {
                        if(record?.travelSegment == null){
                            return <span><I18N>ssp.title.locations.nonTravel</I18N></span>
                        }
                        else{
                            return <span><I18N>ssp.title.locations.travel</I18N></span>
                        }
                    },
                    width: '10%'
                },
                {
                    title: <I18N>ssp.address.streetaddress</I18N>,
                    dataIndex: 'address.streetAddress',
                    render: (_, {streetAddress}) => {
                        return <span>{streetAddress}</span>
                    },
                    width: '25%'
                },
                {
                    title: <I18N>ssp.address.date.range</I18N>,
                    dataIndex: 'address.arriveDate',
                    render: (_, { arriveDate, expireDate }) =>
                        `${arriveDate} - ${expireDate}`,
                    width: '20%'
                },
                {
                    title: 'Action',
                    dataIndex: 'id',
                    hidden: false,
                    render: (_, record) => actionColumnRender(record),
                    width: '25%'
                },
            ].filter((column) => !column.hidden),
        []
    ) :

    useMemo(
      () =>
          [
              {
                  title: <I18N>ssp.address.locationname</I18N>,
                  dataIndex: 'address.locationName',
                  render: (_, {locationName}) => {
                      return <span>{locationName}</span>
                  },
              },
              {
                  title: <I18N>ssp.address.streetaddress</I18N>,
                  dataIndex: 'address.streetAddress',
                  render: (_, {streetAddress}) => {
                      return <span>{streetAddress}</span>
                  },
              },
              {
                  title: <I18N>ssp.address.date.range</I18N>,
                  dataIndex: 'address.arriveDate',
                  render: (_, { arriveDate, expireDate }) =>
                      `${arriveDate} - ${expireDate}`,
              },
          ].filter((column) => !column.hidden),
      []
  )

  const handleTableChange = (
    pagination
) => {
    const { pageSize, current } = pagination

    const sord = 'desc'

    setParams((preParams) => ({
        ...preParams,
        pageSize: pageSize,
        pageNo: current,
        sidx: 'address.arriveDate',
        sord,
    }))
}

    const { dataSource, pagination } = useMemo(() => {
        
        const { currentPageNo = 1, pageSize = 5, totalCount = 0, start = 1 } = expectedLocations ?? {}
        const dataSource = (expectedLocations?.data ?? []).map((item) => ({
            ...item.address,
            id: item.id,
            travelSegment: item.travelSegment
        }))
        return {
            dataSource,
            pagination: {
                current: currentPageNo,
                pageSize: pageSize,
                pageSizeOptions: ['5', '10', '15', '50', '100'],
                total: totalCount,
                position: ['bottomCenter'],
                showSizeChanger: true,
                showTitle: false,
                showQuickJumper: false,
                showTotal: (total) =>
                    dataSource.length > 0
                        ? i18n.get('event.table.pagination.pageInfo', start + 1, start + dataSource.length, total)
                        : undefined,
            },
        }
    }, [expectedLocations])

    return (
        <>
        <div>
            {pagination?.total !== 0 &&
                <Table
                    {...{ columns, dataSource, pagination }}
                    data-testid="contact_expectedLocation_table"
                    size="middle"
                    rowKey={(_, index) => String(index)}
                    sortDirections={['ascend', 'descend', 'ascend']}
                    onChange={handleTableChange}
                />
                }
                {expLocEditable && isAction && (
                    <div className="p-2 text-right">
                        <a
                            href="JavaScript:void(0);"
                            onClick={() => {setIsExpectedLocation(true); openAddLocation()}}
                            eb-test="ssp_location_link_add_address">
                            <I18N>ssp.location.add.expected.address</I18N>
                        </a>
                    </div>
                )}
        </div>
        </>

    );
}

const getExpectedLocation = ({ contactId, _search, pageSize, pageNo, sidx, sord}) => {
    const params = {
        contactId: contactId,
        _search: _search,
        pageSize: pageSize, 
        pageNo: pageNo, 
        sidx: sidx, 
        sord: sord
    }
    
    const url = `/${orgId}/${contactId}/addresses/expectedLocations`;
    Ajax.post(url, qs.stringify(params)).then(({ data }) => {
      }).catch(err => {
        
      });
}

ExpectedLocationList.propTypes = {
  getExpectedLocationList: PropTypes.func.isRequired,
  expectedLocations: PropTypes.object,
  expLocExpose: PropTypes.bool,
  expLocEditable: PropTypes.bool,
};

ExpectedLocationList.defaultProps = {
  expectedLocations: {},
  expLocExpose: false,
  expLocEditable: false,
};

const mapStateToProps = state => ({
  expectedLocations: locationSelectors.expectedLocations(state),
  expLocExpose: locationSelectors.expLocExpose(state),
  expLocEditable: locationSelectors.expLocEditable(state),
});

const mapDispatchToProps = dispatch => ({
    getExpectedLocationList: (contactId, params) => dispatch(locationActions.getExpectedLocationList.action({ contactId, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExpectedLocationList);
